import { Result } from "@cartographerio/fp";
import { isPoint } from "@cartographerio/geometry";
import { hasOptionalKey, isNullable, isObject, isString, } from "@cartographerio/guard";
import { Thames21SlowFlowSiteEnum, Thames21SlowFlowSurveyTypeEnum, } from "@cartographerio/inventory-enums";
import { isTimestamp } from "@cartographerio/types";
export function isPartialData(data) {
    return (isObject(data) &&
        hasOptionalKey(data, "recorded", isNullable(isTimestamp)) &&
        hasOptionalKey(data, "location", isNullable(isPoint)) &&
        hasOptionalKey(data, "surveyType", isNullable(Thames21SlowFlowSurveyTypeEnum.isValue)) &&
        hasOptionalKey(data, "site", isNullable(Thames21SlowFlowSiteEnum.isValue)) &&
        hasOptionalKey(data, "otherSite", isNullable(isString)));
}
export function dataDescription(data) {
    return Result.guard(isPartialData, "PartialThames21SlowFlow")(data).map(data => [
        data.surveyType == null
            ? "Unknown Survey Type"
            : Thames21SlowFlowSurveyTypeEnum.labelOf(data.surveyType),
        data.site == null
            ? data.otherSite ?? "Unknown Location"
            : Thames21SlowFlowSiteEnum.labelOf(data.site),
    ].join(" at "));
}
export function dataGeometry(data) {
    return Result.guard(isPartialData, "PartialThames21SlowFlow")(data).map(data => data.location ?? null);
}
export function dataTimestamp(data) {
    return Result.guard(isPartialData, "PartialThames21SlowFlow")(data).map(data => data.recorded ?? null);
}
export function copyData(data) {
    return Result.guard(isPartialData, "PartialThames21SlowFlow")(data).map(data => ({
        ...data,
        recorded: null,
    }));
}
//# sourceMappingURL=parts.js.map